{
  "familyId": "TIJD-KALENDER",
  "questions": [
    {
      "id": "TIJD-KALENDER-001",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het maandag 3 maart. Welke dag is het over 1 week?",
      "options": [
        "maandag 10 maart",
        "zondag 10 maart",
        "dinsdag 10 maart",
        "maandag 9 maart"
      ],
      "correctAnswer": 0,
      "conceptId": "calendar_one_week",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "tijd.week-same-weekday-missed", "label": "Dag schuift met 7 dagen, terwijl 7 dagen = zelfde dag", "optionIndex": 1 },
          { "id": "tijd.week-same-weekday-missed", "label": "Dag schuift de andere kant op", "optionIndex": 2 },
          { "id": "tijd.calendar-date-arithmetic-error", "label": "3 + 7 verkeerd berekend", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "calendar",
          "data": {
            "year": 2025,
            "month": 3,
            "todayDate": 3,
            "targetDate": 10,
            "highlightDates": [3, 4, 5, 6, 7, 8, 9, 10]
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "1 week verder",
            "content": "1 week = 7 dagen. Over 7 dagen is het altijd dezelfde dag van de week (maandag). Datum: 3 + 7 = 10 maart.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "1 week is precies 7 dagen. Over 7 dagen is het dezelfde dag van de week (maandag). Datum: 3 + 7 = 10 maart.",
        "solutionSteps": [
          "1 week = 7 dagen → dezelfde dag van de week",
          "Maandag + 7 dagen = maandag",
          "Datum: 3 + 7 = 10 maart",
          "Controleer op de kalender: 1 rij naar beneden is 1 week later ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Maandag + 7 dagen = maandag 10 maart.",
          "1": "Over 7 dagen is het dezelfde dag van de week (maandag), niet de dag ervoor. 3 + 7 = 10 maart.",
          "2": "Over 7 dagen is het dezelfde dag van de week (maandag), niet de dag erna. 3 + 7 = 10 maart.",
          "3": "De datum klopt niet. 3 + 7 = 10, niet 9. Het is maandag 10 maart."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-002",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het zaterdag 12 april. Welke dag is het over 4 dagen?",
      "options": [
        "woensdag 16 april",
        "dinsdag 16 april",
        "donderdag 16 april",
        "woensdag 15 april"
      ],
      "correctAnswer": 0,
      "conceptId": "calendar_days_forward",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "tijd.weekday-off-by-one", "label": "Eén dag te weinig geteld", "optionIndex": 1 },
          { "id": "tijd.weekday-off-by-one", "label": "Eén dag te veel geteld", "optionIndex": 2 },
          { "id": "tijd.calendar-date-arithmetic-error", "label": "12 + 4 verkeerd berekend", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "calendar",
          "data": {
            "year": 2025,
            "month": 4,
            "todayDate": 12,
            "targetDate": 16
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "4 dagen verder tellen",
            "content": "Zaterdag + 4 dagen: zondag (1), maandag (2), dinsdag (3), woensdag (4). Datum: 12 + 4 = 16 april.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Zaterdag + 4 dagen: zondag (1), maandag (2), dinsdag (3), woensdag (4). Datum: 12 + 4 = 16 april.",
        "solutionSteps": [
          "Tel de dagen: za → zo (1) → ma (2) → di (3) → wo (4)",
          "Datum: 12 + 4 = 16 april",
          "Controleer op de kalender: 4 vakjes naar rechts/onder tellen ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Zaterdag + 4 = woensdag 16 april.",
          "1": "Je hebt maar 3 dagen geteld. Zaterdag + 4 = woensdag (za → zo → ma → di → wo).",
          "2": "Je hebt 5 dagen geteld in plaats van 4. Zaterdag + 4 = woensdag.",
          "3": "De datum klopt niet. 12 + 4 = 16, niet 15. Het is woensdag 16 april."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-003",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_kalender",
      "questionType": "fill_in",
      "question": "Bekijk de kalender. Hoeveel dagen later is maandag 17 maart dan woensdag 5 maart?",
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["12", "12 dagen"],
        "placeholder": "aantal dagen",
        "inputType": "number"
      },
      "conceptId": "calendar_count_between",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.68,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.calendar-date-arithmetic-error", "label": "Off-by-one bij verschil-berekening (inclusief/exclusief eindpunt)" }
        ]
      },
      "stimulusAids": [
        {
          "type": "calendar",
          "data": {
            "year": 2025,
            "month": 3,
            "todayDate": 5,
            "targetDate": 17,
            "highlightDates": [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Dagen ertussen berekenen",
            "content": "Trek de begindatum af van de einddatum: 17 − 5 = 12 dagen. Je kunt ze ook tellen op de kalender.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Om het aantal dagen te berekenen, trek je de begindatum af van de einddatum: 17 − 5 = 12 dagen.",
        "solutionSteps": [
          "Einddatum = 17 maart",
          "Begindatum = 5 maart",
          "Verschil = 17 − 5 = 12 dagen",
          "Controleer door te tellen op de kalender: 12 vakjes verder ✓"
        ]
      }
    },
    {
      "id": "TIJD-KALENDER-004",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het zaterdag 27 september. Welke dag is het over 6 dagen?",
      "options": [
        "vrijdag 3 oktober",
        "donderdag 3 oktober",
        "vrijdag 2 oktober",
        "zaterdag 3 oktober"
      ],
      "correctAnswer": 0,
      "conceptId": "calendar_month_boundary",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.weekday-off-by-one", "label": "Eén dag te weinig geteld (vrijdag → donderdag)", "optionIndex": 1 },
          { "id": "tijd.month-boundary-not-applied", "label": "September behandeld als 31 dagen i.p.v. 30", "optionIndex": 2 },
          { "id": "tijd.week-same-weekday-missed", "label": "Dag van de week niet doorgerekend", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "calendar",
          "data": {
            "year": 2025,
            "month": 9,
            "todayDate": 27,
            "secondMonth": 10,
            "secondMonthYear": 2025,
            "secondMonthTarget": 3
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Maandgrens overschrijden",
            "content": "Zaterdag + 6 dagen = vrijdag. Datum: 27 + 6 = 33. September heeft 30 dagen, dus 33 − 30 = 3 oktober.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Zaterdag + 6 dagen = vrijdag. Datum: 27 + 6 = 33. September heeft 30 dagen: 33 − 30 = 3 oktober.",
        "solutionSteps": [
          "Tel de dagen: za + 6 = vrijdag",
          "Datum: 27 + 6 = 33",
          "September heeft 30 dagen → 33 − 30 = 3 oktober",
          "Controleer op de kalender: tel 6 dagen verder naar de volgende maand ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Zaterdag + 6 = vrijdag 3 oktober.",
          "1": "Je hebt maar 5 dagen geteld. Zaterdag + 6 = vrijdag.",
          "2": "De datum klopt niet. 27 + 6 = 33. September heeft 30 dagen: 33 − 30 = 3 oktober, niet 2.",
          "3": "Over 6 dagen is het niet dezelfde dag van de week. Zaterdag + 6 = vrijdag."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-005",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_kalender",
      "questionType": "fill_in",
      "question": "Bekijk de kalender van mei. Op welke datum valt de derde donderdag?",
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["15", "15 mei"],
        "placeholder": "datum (getal)",
        "inputType": "number"
      },
      "conceptId": "calendar_nth_weekday",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.69,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.weekday-off-by-one", "label": "Verkeerde n-de weekdag geteld (off-by-one in de kolom)" }
        ]
      },
      "stimulusAids": [
        {
          "type": "calendar",
          "data": {
            "year": 2025,
            "month": 5
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Derde donderdag zoeken",
            "content": "Kijk in de kolom van donderdag ('do'). De eerste is 1 mei, de tweede is 8 mei, de derde is 15 mei.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Kijk in de kolom van donderdag ('do'). De eerste donderdag is 1 mei, de tweede is 8 mei, de derde is 15 mei.",
        "solutionSteps": [
          "Zoek de kolom van donderdag ('do')",
          "Tel naar beneden: 1e donderdag = 1 mei",
          "2e donderdag = 8 mei",
          "3e donderdag = 15 mei ✓"
        ]
      }
    },
    {
      "id": "TIJD-KALENDER-006",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het dinsdag 18 februari. Welke dag is het over 2 weken? (Het is geen schrikkeljaar.)",
      "options": [
        "dinsdag 4 maart",
        "dinsdag 3 maart",
        "woensdag 4 maart",
        "dinsdag 2 maart"
      ],
      "correctAnswer": 0,
      "conceptId": "calendar_february_boundary",
      "variantIndex": 6,
      "citoDifficulty": 0.43,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.month-boundary-not-applied", "label": "Schrikkeljaar (29 dagen) toegepast op gewoon jaar", "optionIndex": 1 },
          { "id": "tijd.week-same-weekday-missed", "label": "Dag schuift met 14 dagen, terwijl 14 dagen = zelfde dag", "optionIndex": 2 },
          { "id": "tijd.month-boundary-not-applied", "label": "Februari behandeld als 30 dagen i.p.v. 28", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "calendar",
          "data": {
            "year": 2025,
            "month": 2,
            "todayDate": 18,
            "secondMonth": 3,
            "secondMonthYear": 2025,
            "secondMonthTarget": 4
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Februari en maandgrens",
            "content": "2 weken = 14 dagen → dezelfde dag (dinsdag). Datum: 18 + 14 = 32. Februari heeft 28 dagen: 32 − 28 = 4 maart.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "2 weken is 14 dagen. Over 14 dagen is het dezelfde dag (dinsdag). Datum: 18 + 14 = 32. Februari heeft 28 dagen: 32 − 28 = 4 maart.",
        "solutionSteps": [
          "2 weken = 14 dagen → dezelfde dag van de week (dinsdag)",
          "Datum: 18 + 14 = 32",
          "Februari heeft 28 dagen (gewoon jaar) → 32 − 28 = 4 maart",
          "Controleer op de kalender: 2 rijen naar beneden ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Dinsdag + 14 = dinsdag 4 maart.",
          "1": "In een schrikkeljaar heeft februari 29 dagen, dan zou het 3 maart zijn. Maar het is een gewoon jaar met 28 dagen: 32 − 28 = 4 maart.",
          "2": "Over 14 dagen is het dezelfde dag van de week (dinsdag), niet de dag erna.",
          "3": "De datum klopt niet. 18 + 14 = 32. Februari heeft 28 dagen: 32 − 28 = 4 maart, niet 2 maart."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-007",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_kalender",
      "questionType": "fill_in",
      "question": "Februari heeft normaal 28 dagen. In een schrikkeljaar heeft februari 29 dagen. Hoeveel dagen heeft het jaar 2028 in totaal?",
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["366", "366 dagen"],
        "placeholder": "aantal dagen",
        "inputType": "number"
      },
      "conceptId": "calendar_leap_year_days",
      "variantIndex": 7,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.65,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "tijd.month-boundary-not-applied", "label": "Schrikkeldag (29 februari) niet meegerekend" }
        ]
      },
      "stimulusAids": [
        {
          "type": "calendar",
          "data": {
            "year": 2028,
            "month": 2,
            "highlightDates": [29]
          },
          "a11y": { "alt": "Kalender van februari 2028 met de extra schrikkeldag 29 februari gemarkeerd" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Dagen in een jaar",
            "content": "Een normaal jaar heeft 365 dagen. Een schrikkeljaar heeft 1 dag extra (29 februari), dus 365 + 1 = 366 dagen.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Een normaal jaar heeft 365 dagen. Een schrikkeljaar heeft 1 dag extra (29 februari), dus 365 + 1 = 366 dagen.",
        "solutionSteps": [
          "Een normaal jaar heeft 365 dagen",
          "Een schrikkeljaar heeft 1 dag extra in februari",
          "365 + 1 = 366 dagen",
          "Controleer: 2028 is deelbaar door 4, dus het is een schrikkeljaar ✓"
        ]
      }
    },
    {
      "id": "TIJD-KALENDER-008",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het zondag 28 december. Welke dag is het over 5 dagen?",
      "options": [
        "vrijdag 2 januari",
        "donderdag 2 januari",
        "vrijdag 1 januari",
        "zaterdag 2 januari"
      ],
      "correctAnswer": 0,
      "conceptId": "calendar_year_boundary",
      "variantIndex": 8,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.weekday-off-by-one", "label": "Eén dag te weinig geteld", "optionIndex": 1 },
          { "id": "tijd.month-boundary-not-applied", "label": "December behandeld als 30 dagen i.p.v. 31", "optionIndex": 2 },
          { "id": "tijd.weekday-off-by-one", "label": "Eén dag te veel geteld", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "calendar",
          "data": {
            "year": 2025,
            "month": 12,
            "todayDate": 28,
            "secondMonth": 1,
            "secondMonthYear": 2026,
            "secondMonthTarget": 2
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Jaargrens overschrijden",
            "content": "Zondag + 5 dagen = vrijdag. Datum: 28 + 5 = 33. December heeft 31 dagen: 33 − 31 = 2 januari.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Zondag + 5 dagen = vrijdag. Datum: 28 + 5 = 33. December heeft 31 dagen: 33 − 31 = 2 januari.",
        "solutionSteps": [
          "Tel de dagen: zo → ma (1) → di (2) → wo (3) → do (4) → vr (5)",
          "Datum: 28 + 5 = 33",
          "December heeft 31 dagen → 33 − 31 = 2 januari",
          "Controleer op de kalender: tel 5 dagen verder naar de volgende maand ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Zondag + 5 = vrijdag 2 januari.",
          "1": "Je hebt maar 4 dagen geteld. Zondag + 5 = vrijdag (zo → ma → di → wo → do → vr).",
          "2": "De datum klopt niet. 28 + 5 = 33. December heeft 31 dagen: 33 − 31 = 2 januari, niet 1.",
          "3": "Je hebt 6 dagen geteld in plaats van 5. Zondag + 5 = vrijdag."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-009",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_kalender",
      "questionType": "fill_in",
      "question": "Het is maandag 6 oktober. Over hoeveel dagen is het zaterdag 18 oktober?",
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["12", "12 dagen"],
        "placeholder": "aantal dagen",
        "inputType": "number"
      },
      "conceptId": "calendar_count_forward",
      "variantIndex": 9,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.69,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.calendar-date-arithmetic-error", "label": "Verschil-berekening met off-by-one fout" }
        ]
      },
      "stimulusAids": [
        {
          "type": "calendar",
          "data": {
            "year": 2025,
            "month": 10,
            "todayDate": 6,
            "targetDate": 18,
            "highlightDates": [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Dagen vooruit tellen",
            "content": "Trek de begindatum af van de einddatum: 18 − 6 = 12 dagen. Je kunt ze ook tellen op de kalender.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Om het aantal dagen te berekenen, trek je de begindatum af van de einddatum: 18 − 6 = 12 dagen.",
        "solutionSteps": [
          "Einddatum = 18 oktober",
          "Begindatum = 6 oktober",
          "Verschil = 18 − 6 = 12 dagen",
          "Controleer door te tellen op de kalender: 12 vakjes verder ✓"
        ]
      }
    },
    {
      "id": "TIJD-KALENDER-010",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het zondag 15 juni. Welke dag was het 4 dagen geleden?",
      "options": [
        "woensdag 11 juni",
        "donderdag 11 juni",
        "woensdag 12 juni",
        "dinsdag 11 juni"
      ],
      "correctAnswer": 0,
      "conceptId": "calendar_count_back",
      "variantIndex": 10,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.weekday-off-by-one", "label": "Eén dag te weinig teruggeteld", "optionIndex": 1 },
          { "id": "tijd.calendar-date-arithmetic-error", "label": "15 − 4 verkeerd berekend", "optionIndex": 2 },
          { "id": "tijd.weekday-off-by-one", "label": "Eén dag te veel teruggeteld", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "calendar",
          "data": {
            "year": 2025,
            "month": 6,
            "todayDate": 15,
            "targetDate": 11,
            "highlightDates": [11, 12, 13, 14, 15]
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Dagen terug tellen",
            "content": "Zondag − 4 dagen: zaterdag (1), vrijdag (2), donderdag (3), woensdag (4). Datum: 15 − 4 = 11 juni.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Zondag − 4 dagen: zaterdag (1), vrijdag (2), donderdag (3), woensdag (4). Datum: 15 − 4 = 11 juni.",
        "solutionSteps": [
          "Tel de dagen terug: zo → za (1) → vr (2) → do (3) → wo (4)",
          "Datum: 15 − 4 = 11 juni",
          "Controleer op de kalender: 4 vakjes naar links/boven tellen ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Zondag − 4 = woensdag 11 juni.",
          "1": "Je hebt maar 3 dagen teruggeteld. Zondag − 4 = woensdag (zo → za → vr → do → wo).",
          "2": "De datum klopt niet. 15 − 4 = 11, niet 12. Het is woensdag 11 juni.",
          "3": "Je hebt 5 dagen teruggeteld in plaats van 4. Zondag − 4 = woensdag."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-011",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_kalender",
      "questionType": "fill_in",
      "question": "Bekijk de kalender van november. Hoeveel zaterdagen heeft november als de 1e op een vrijdag valt?",
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["5", "5 zaterdagen"],
        "placeholder": "aantal zaterdagen",
        "inputType": "number"
      },
      "conceptId": "calendar_count_weekday",
      "variantIndex": 11,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.68,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.weekday-off-by-one", "label": "Verkeerde startdag voor de weekdag-kolom" }
        ]
      },
      "stimulusAids": [
        {
          "type": "calendar",
          "data": {
            "year": 2024,
            "month": 11,
            "highlightDates": [2, 9, 16, 23, 30]
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Dagen in een maand tellen",
            "content": "Als 1 november een vrijdag is, is 2 november een zaterdag. De zaterdagen zijn dan: 2, 9, 16, 23 en 30 november. Dat zijn er 5.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Als 1 november een vrijdag is, is 2 november een zaterdag. De zaterdagen zijn dan: 2, 9, 16, 23 en 30 november. Dat zijn er 5.",
        "solutionSteps": [
          "Zoek de kolom van zaterdag ('za')",
          "De eerste zaterdag is 2 november",
          "Tel de zaterdagen: 2, 9, 16, 23, 30",
          "Dat zijn in totaal 5 zaterdagen ✓"
        ]
      }
    },
    {
      "id": "TIJD-KALENDER-012",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het donderdag 23 januari. Welke dag is het over 3 weken?",
      "options": [
        "donderdag 13 februari",
        "donderdag 12 februari",
        "vrijdag 13 februari",
        "woensdag 13 februari"
      ],
      "correctAnswer": 0,
      "conceptId": "calendar_three_weeks_boundary",
      "variantIndex": 12,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.calendar-date-arithmetic-error", "label": "23 + 21 of 44 − 31 verkeerd berekend", "optionIndex": 1 },
          { "id": "tijd.week-same-weekday-missed", "label": "Dag schuift met 21 dagen, terwijl 21 = 3×7 = zelfde dag", "optionIndex": 2 },
          { "id": "tijd.week-same-weekday-missed", "label": "Dag schuift de andere kant op", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "calendar",
          "data": {
            "year": 2025,
            "month": 1,
            "todayDate": 23,
            "secondMonth": 2,
            "secondMonthYear": 2025,
            "secondMonthTarget": 13
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "3 weken verder met maandgrens",
            "content": "3 weken = 21 dagen → dezelfde dag (donderdag). Datum: 23 + 21 = 44. Januari heeft 31 dagen: 44 − 31 = 13 februari.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "3 weken = 21 dagen → dezelfde dag (donderdag). Datum: 23 + 21 = 44. Januari heeft 31 dagen: 44 − 31 = 13 februari.",
        "solutionSteps": [
          "3 weken = 21 dagen = 3 × 7 → dezelfde dag van de week (donderdag)",
          "Datum: 23 + 21 = 44",
          "Januari heeft 31 dagen → 44 − 31 = 13 februari",
          "Controleer op de kalender: tel 3 rijen naar beneden ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Donderdag + 21 = donderdag 13 februari.",
          "1": "De datum klopt niet. 23 + 21 = 44. Januari heeft 31 dagen: 44 − 31 = 13 februari, niet 12.",
          "2": "Over 21 dagen is het dezelfde dag van de week (donderdag), niet de dag erna.",
          "3": "Over 21 dagen is het dezelfde dag van de week (donderdag), niet de dag ervoor."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-013",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "De zomervakantie begint op vrijdag 18 juli en duurt 6 weken. Op welke datum begint de school weer?",
      "options": [
        "29 augustus",
        "25 augustus",
        "1 september",
        "22 augustus"
      ],
      "correctAnswer": 0,
      "conceptId": "calendar_weeks_duration",
      "variantIndex": 13,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "tijd.calendar-date-arithmetic-error", "label": "5 weken (35 dagen) geteld i.p.v. 6 weken (42)", "optionIndex": 1 },
          { "id": "tijd.calendar-date-arithmetic-error", "label": "Te veel dagen opgeteld (6 weken + 3 extra)", "optionIndex": 2 },
          { "id": "tijd.calendar-date-arithmetic-error", "label": "5 weken (35 dagen) geteld i.p.v. 6 weken (42)", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "calendar",
          "data": {
            "year": 2025,
            "month": 7,
            "todayDate": 18,
            "secondMonth": 8,
            "secondMonthYear": 2025,
            "secondMonthTarget": 29
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Weken optellen",
            "content": "6 weken = 6 × 7 = 42 dagen. Datum: 18 + 42 = 60. Juli heeft 31 dagen: 60 − 31 = 29 augustus.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "6 weken is 42 dagen. Datum: 18 + 42 = 60. Juli heeft 31 dagen: 60 − 31 = 29 augustus.",
        "solutionSteps": [
          "6 weken = 6 × 7 = 42 dagen",
          "Datum: 18 + 42 = 60",
          "Juli heeft 31 dagen → 60 − 31 = 29 augustus",
          "Controleer op de kalender: tel 6 rijen naar beneden ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 18 juli + 42 dagen = 29 augustus.",
          "1": "25 augustus klopt niet. Je hebt maar 5 weken (35 dagen) geteld in plaats van 6 weken (42 dagen). 18 + 42 = 60. 60 − 31 = 29 augustus.",
          "2": "1 september klopt niet. Je hebt 45 dagen geteld (6 weken + 3 extra). 6 weken = precies 42 dagen. 18 + 42 = 60. 60 − 31 = 29 augustus.",
          "3": "22 augustus klopt niet. Je hebt maar 5 weken (35 dagen) geteld. 6 weken = 42 dagen. 18 + 42 = 60. 60 − 31 = 29 augustus."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-014",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Vandaag is het woensdag 30 april. Welke dag is het over 9 dagen?",
      "options": [
        "vrijdag 9 mei",
        "donderdag 9 mei",
        "vrijdag 8 mei",
        "zaterdag 9 mei"
      ],
      "correctAnswer": 0,
      "conceptId": "calendar_nine_days_boundary",
      "variantIndex": 14,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.week-same-weekday-missed", "label": "Alleen het 7-dagen deel toegepast, 2 extra dagen vergeten", "optionIndex": 1 },
          { "id": "tijd.month-boundary-not-applied", "label": "April behandeld als 31 dagen i.p.v. 30", "optionIndex": 2 },
          { "id": "tijd.weekday-off-by-one", "label": "Eén dag te veel geteld", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "calendar",
          "data": {
            "year": 2025,
            "month": 4,
            "todayDate": 30,
            "secondMonth": 5,
            "secondMonthYear": 2025,
            "secondMonthTarget": 9
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "9 dagen verder met maandgrens",
            "content": "9 = 7 + 2 dagen. Woensdag + 2 = vrijdag. Datum: 30 + 9 = 39. April heeft 30 dagen: 39 − 30 = 9 mei.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "9 = 7 + 2. Woensdag + 2 extra dagen = vrijdag. Datum: 30 + 9 = 39. April heeft 30 dagen: 39 − 30 = 9 mei.",
        "solutionSteps": [
          "9 dagen = 7 + 2 → 1 week + 2 dagen extra",
          "Woensdag + 2 dagen = vrijdag",
          "Datum: 30 + 9 = 39. April heeft 30 dagen → 39 − 30 = 9 mei",
          "Controleer op de kalender: tel 9 dagen verder ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Woensdag + 9 = vrijdag 9 mei.",
          "1": "Over 7 dagen is het woensdag, maar het zijn 9 dagen. 9 = 7 + 2, dus 2 dagen verder = vrijdag.",
          "2": "De datum klopt niet. 30 + 9 = 39. April heeft 30 dagen: 39 − 30 = 9 mei, niet 8.",
          "3": "Je hebt 10 dagen geteld in plaats van 9. Woensdag + 9 = vrijdag."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-015",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_kalender",
      "questionType": "multiple_choice",
      "question": "Het schoolreisje is op donderdag 22 mei. Vandaag is het maandag 5 mei. Hoeveel weken en dagen moet je nog wachten?",
      "options": [
        "2 weken en 3 dagen",
        "2 weken en 4 dagen",
        "3 weken",
        "2 weken en 2 dagen"
      ],
      "correctAnswer": 0,
      "conceptId": "calendar_weeks_and_days",
      "variantIndex": 15,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.68,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "tijd.calendar-date-arithmetic-error", "label": "Verschil 1 dag te veel geteld", "optionIndex": 1 },
          { "id": "tijd.week-same-weekday-missed", "label": "3 weken (21 dagen) i.p.v. 17 dagen geteld", "optionIndex": 2 },
          { "id": "tijd.calendar-date-arithmetic-error", "label": "Verschil 1 dag te weinig geteld", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "calendar",
          "data": {
            "year": 2025,
            "month": 5,
            "todayDate": 5,
            "targetDate": 22,
            "highlightDates": [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22]
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Weken en dagen berekenen",
            "content": "Verschil: 22 − 5 = 17 dagen. 17 dagen = 14 dagen + 3 dagen = 2 weken en 3 dagen.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Trek de begindatum af van de einddatum: 22 − 5 = 17 dagen. Zet dit om in weken: 17 dagen = 14 dagen + 3 dagen = 2 weken en 3 dagen.",
        "solutionSteps": [
          "Bereken het verschil in dagen: 22 − 5 = 17 dagen",
          "1 week = 7 dagen, 2 weken = 14 dagen",
          "17 dagen = 14 dagen + 3 dagen",
          "Antwoord: 2 weken en 3 dagen ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 22 − 5 = 17 dagen = 2 weken en 3 dagen.",
          "1": "Je hebt 1 dag te veel geteld. Het verschil is 17 dagen, niet 18. 17 = 14 + 3 = 2 weken en 3 dagen.",
          "2": "3 weken = 21 dagen, maar het verschil is maar 17 dagen. 17 = 14 + 3 = 2 weken en 3 dagen.",
          "3": "Je hebt 1 dag te weinig geteld. Het verschil is 17 dagen, niet 16. 17 = 14 + 3 = 2 weken en 3 dagen."
        }
      }
    },
    {
      "id": "TIJD-KALENDER-016",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_kalender",
      "questionType": "ordering",
      "question": "Zet deze gebeurtenissen in de juiste volgorde van vroeg naar laat in het jaar.",
      "data": {
        "items": [
          "Sinterklaas (5 december)",
          "Nieuwjaarsdag (1 januari)",
          "Zomervakantie start (juli)",
          "Koningsdag (27 april)"
        ],
        "correctOrder": [1, 3, 2, 0]
      },
      "correctAnswer": 0,
      "conceptId": "calendar_event_order",
      "variantIndex": 16,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.65,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "tijd.calendar-date-arithmetic-error", "label": "Maand-volgorde door elkaar (bijv. schoolritme i.p.v. kalenderjaar)" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Volgorde van maanden",
            "content": "Denk aan de volgorde van de maanden: januari → april → juli → december. Nieuwjaar is in januari, Koningsdag in april, zomervakantie in juli en Sinterklaas in december.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De volgorde is: Nieuwjaarsdag (januari) → Koningsdag (april) → Zomervakantie (juli) → Sinterklaas (december). Dit volgt de volgorde van de maanden in het jaar.",
        "solutionSteps": [
          "Zoek de maand van elke gebeurtenis",
          "Nieuwjaarsdag = januari (maand 1)",
          "Koningsdag = april (maand 4), Zomervakantie = juli (maand 7)",
          "Sinterklaas = december (maand 12) → volgorde: jan → apr → jul → dec ✓"
        ]
      }
    },
    {
      "id": "TIJD-KALENDER-017",
      "familyId": "TIJD-KALENDER",
      "module": "Tijd",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_kalender",
      "questionType": "matching",
      "question": "Bekijk de kalender van maart 2025. Koppel elke datum aan de juiste dag van de week.",
      "data": {
        "leftItems": ["3 maart", "7 maart", "11 maart", "20 maart"],
        "rightItems": ["maandag", "vrijdag", "dinsdag", "donderdag"],
        "correctMatches": {"0": 0, "1": 1, "2": 2, "3": 3}
      },
      "correctAnswer": 0,
      "conceptId": "calendar_match_day",
      "variantIndex": 17,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.67,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.weekday-off-by-one", "label": "Verkeerde kolom afgelezen voor de datum" }
        ]
      },
      "stimulusAids": [
        {
          "type": "calendar",
          "data": {
            "year": 2025,
            "month": 3,
            "highlightDates": [3, 7, 11, 20]
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Dag van de week aflezen",
            "content": "Zoek elke datum op de kalender en kijk in welke kolom die staat. De kolommen zijn: ma, di, wo, do, vr, za, zo. Zoek het getal en kijk recht omhoog naar de dagafkorting.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Zoek elke datum op de kalender en kijk in welke kolom die staat. 3 maart staat in de kolom 'ma' (maandag), 7 maart in 'vr' (vrijdag), 11 maart in 'di' (dinsdag) en 20 maart in 'do' (donderdag).",
        "solutionSteps": [
          "Zoek 3 maart op de kalender → kolom 'ma' = maandag",
          "Zoek 7 maart → kolom 'vr' = vrijdag",
          "Zoek 11 maart → kolom 'di' = dinsdag",
          "Zoek 20 maart → kolom 'do' = donderdag ✓"
        ]
      }
    }
  ]
}